{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} y {{ moreCount }} más",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} y {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} archivo",
  "{{ count }} files_many": "{{ count }} archivos",
  "{{ count }} files_other": "{{ count }} archivos",
  "{{ count }} people are typing_one": "{{ count }} persona está escribiendo",
  "{{ count }} people are typing_many": "{{ count }} personas están escribiendo",
  "{{ count }} people are typing_other": "{{ count }} personas están escribiendo",
  "{{ count }} photos_one": "{{ count }} foto",
  "{{ count }} photos_many": "{{ count }} fotos",
  "{{ count }} photos_other": "{{ count }} fotos",
  "{{ count }} reactions_one": "{{ count }} reacción",
  "{{ count }} reactions_many": "{{ count }} reacciones",
  "{{ count }} reactions_other": "{{ count }} reacciones",
  "{{ count }} videos_one": "{{ count }} vídeo",
  "{{ count }} videos_many": "{{ count }} vídeos",
  "{{ count }} videos_other": "{{ count }} vídeos",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} y {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} más",
  "{{ memberCount }} members": "{{ memberCount }} miembros",
  "{{ typing }} are typing": "{{ typing }} están escribiendo",
  "{{ typing }} is typing": "{{ typing }} está escribiendo",
  "{{ user }} has been muted": "{{ user }} ha sido silenciado",
  "{{ user }} has been unmuted": "Se ha desactivado el silencio de {{ user }}",
  "{{ user }} is typing...": "{{ user }} está escribiendo...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} y {{ user }} están escribiendo...",
  "{{ users }} and more are typing...": "{{ users }} y más están escribiendo...",
  "{{ watcherCount }} online": "{{ watcherCount }} en línea",
  "{{count}} new messages_one": "{{count}} nuevo mensaje",
  "{{count}} new messages_many": "{{count}} nuevos mensajes",
  "{{count}} new messages_other": "{{count}} nuevos mensajes",
  "{{count}} unread_one": "{{count}} no leído",
  "{{count}} unread_many": "{{count}} no leídos",
  "{{count}} unread_other": "{{count}} no leídos",
  "{{count}} votes_one": "1 voto",
  "{{count}} votes_many": "{{count}} votos",
  "{{count}} votes_other": "{{count}} votos",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} opción más",
  "+{{count}} more options_many": "+{{count}} opciones más",
  "+{{count}} more options_other": "+{{count}} opciones más",
  "🏙 Attachment...": "🏙 Adjunto...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} creó: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} votó: {{pollOptionText}}",
  "📍Shared location": "📍Ubicación compartida",
  "Add a comment": "Agregar un comentario",
  "Add a comment to your poll answer": "Añade un comentario a tu respuesta de la encuesta",
  "Add an option": "Agregar una opción",
  "Add reaction": "Añadir reacción",
  "All results loaded": "Todos los resultados cargados",
  "Allow access to camera": "Permitir acceso a la cámara",
  "Allow access to microphone": "Permitir acceso al micrófono",
  "Allow comments": "Permitir comentarios",
  "Allow option suggestion": "Permitir sugerencia de opciones",
  "Allow others to add comments": "Permitir que otros añadan comentarios",
  "Also send as a direct message": "También enviar como mensaje directo",
  "Also send in channel": "También enviar en el canal",
  "Also sent in channel": "También enviado en el canal",
  "An error has occurred during recording": "Se ha producido un error durante la grabación",
  "An error has occurred during the recording processing": "Se ha producido un error durante el procesamiento de la grabación",
  "Anonymous": "Anónimo",
  "Anonymous poll": "Encuesta anónima",
  "Archive": "Archivo",
  "Are you sure you want to delete this message?": "¿Estás seguro de que quieres eliminar este mensaje?",
  "aria/Attachment": "Adjunto",
  "aria/Attachment Actions": "Acciones del adjunto",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Posición de audio {{ elapsed }} de {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Posición de audio {{ progress }} por ciento",
  "aria/Block User": "Bloquear usuario",
  "aria/Bookmark Message": "Guardar mensaje",
  "aria/Cancel recording": "Cancelar grabación",
  "aria/Cancel Reply": "Cancelar respuesta",
  "aria/Cancel upload": "Cancelar carga",
  "aria/Channel Actions": "Acciones del canal",
  "aria/Channel list": "Lista de canales",
  "aria/Channel search results": "Resultados de búsqueda de canales",
  "aria/Chat view tabs": "Pestañas de vista del chat",
  "aria/Clear search": "Borrar búsqueda",
  "aria/Close callout dialog": "Cerrar diálogo de aviso",
  "aria/Close thread": "Cerrar hilo",
  "aria/Collapse sidebar": "Contraer barra lateral",
  "aria/Command Suggestions": "Sugerencias de comandos",
  "aria/Complete recording": "Completar grabación",
  "aria/Copy Message Text": "Copiar texto del mensaje",
  "aria/Decrease value": "Disminuir valor",
  "aria/Delete Message": "Eliminar mensaje",
  "aria/Dismiss notification": "Descartar notificación",
  "aria/Download attachment": "Descargar adjunto",
  "aria/Edit Message": "Editar mensaje",
  "aria/Emoji picker": "Selector de emojis",
  "aria/Emoji Suggestions": "Sugerencias de emojis",
  "aria/Exit search": "Salir de la búsqueda",
  "aria/Expand sidebar": "Expandir barra lateral",
  "aria/File input": "Entrada de archivo",
  "aria/File upload": "Carga de archivo",
  "aria/Flag Message": "Marcar mensaje",
  "aria/Image failed to load": "Error al cargar la imagen",
  "aria/Image input": "Entrada de imagen",
  "aria/Increase value": "Aumentar valor",
  "aria/Jump to latest message": "Ir al mensaje más reciente",
  "aria/Jump to quoted message": "Ir al mensaje citado",
  "aria/Load More Channels": "Cargar más canales",
  "aria/Mark Message Unread": "Marcar como no leído",
  "aria/Mark messages as read": "Marcar mensajes como leídos",
  "aria/Menu": "Menú",
  "aria/Message Actions": "Acciones del mensaje",
  "aria/Message from {{ user }},": "Mensaje de {{ user }},",
  "aria/Message Options": "Opciones de mensaje",
  "aria/Message,": "Mensaje,",
  "aria/Mute User": "Silenciar usuario",
  "aria/Notifications": "Notificaciones",
  "aria/Open Attachment Selector": "Abrir selector de adjuntos",
  "aria/Open Channel Actions Menu": "Abrir menú de acciones del canal",
  "aria/Open Menu": "Abrir menú",
  "aria/Open Message Actions Menu": "Abrir menú de acciones de mensaje",
  "aria/Open Reaction Selector": "Abrir selector de reacciones",
  "aria/Open Thread": "Abrir hilo",
  "aria/Pause": "Pausar",
  "aria/Pause recording": "Pausar grabación",
  "aria/Percent complete": "{{percent}} por ciento completado",
  "aria/Pin Message": "Fijar mensaje",
  "aria/Play": "Reproducir",
  "aria/Quote Message": "Citar mensaje",
  "aria/Reaction list": "Lista de reacciones",
  "aria/Remind Me Message": "Recordarme",
  "aria/Remind Me Options": "Opciones de recordatorio",
  "aria/Remove attachment": "Eliminar adjunto",
  "aria/Remove location attachment": "Eliminar adjunto de ubicación",
  "aria/Remove option": "Eliminar opción",
  "aria/Remove Reminder": "Quitar recordatorio",
  "aria/Remove Save For Later": "Quitar guardar para después",
  "aria/Resend Message": "Reenviar mensaje",
  "aria/Resume recording": "Reanudar grabación",
  "aria/Retry upload": "Reintentar carga",
  "aria/Review bounced message": "Revisar mensaje rebotado",
  "aria/Search results": "Resultados de búsqueda",
  "aria/Search results header filter button for: {{ source }}": "Botón de filtro del encabezado de resultados de búsqueda para: {{ source }}",
  "aria/Seek audio position": "Buscar posición de audio",
  "aria/Select Channel: {{ channelName }}": "Seleccionar canal: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Seleccionar reacción: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Seleccionar canal de usuario: {{ name }}",
  "aria/Send": "Enviar",
  "aria/Show preview": "Mostrar vista previa",
  "aria/Start recording audio": "Iniciar grabación de audio",
  "aria/Stop AI Generation": "Detener generación de IA",
  "aria/Suggestions": "Sugerencias",
  "aria/Thread list": "Lista de hilos",
  "aria/Unblock User": "Desbloquear usuario",
  "aria/Unmute User": "Activar sonido",
  "aria/Unpin Message": "Desfijar mensaje",
  "aria/User Suggestions": "Sugerencias de usuarios",
  "Ask a question": "Hacer una pregunta",
  "Attach": "Adjuntar",
  "Attach files": "Adjuntar archivos",
  "Attachment": "Archivo adjunto",
  "Attachment upload blocked due to {{reason}}": "Carga de adjunto bloqueada debido a {{reason}}",
  "Attachment upload failed due to {{reason}}": "Carga de adjunto fallida debido a {{reason}}",
  "Back": "Atrás",
  "ban-command-args": "[@usuario] [texto]",
  "ban-command-description": "Prohibir a un usuario",
  "Block User": "Bloquear usuario",
  "Cancel": "Cancelar",
  "Cannot seek in the recording": "No se puede buscar en la grabación",
  "Channel archived": "Canal archivado",
  "Channel Missing": "Falta canal",
  "Channel muted": "Canal silenciado",
  "Channel pinned": "Canal fijado",
  "Channel unarchived": "Canal desarchivado",
  "Channel unmuted": "Silencio del canal desactivado",
  "Channel unpinned": "Canal desanclado",
  "Channels": "Canales",
  "Chats": "Chats",
  "Choose between 2 to 10 options": "Elige entre 2 y 10 opciones",
  "Close": "Cerrar",
  "Close dialog": "Cerrar diálogo",
  "Close emoji picker": "Cerrar el selector de emojis",
  "Close prompt: {{ title }}": "Cerrar diálogo: {{ title }}",
  "Command not available while editing": "Comando no disponible durante la edición",
  "Command not available while replying": "Comando no disponible mientras se responde",
  "Commands": "Comandos",
  "Commands matching": "Coincidencia de comandos",
  "Connection failure, reconnecting now...": "Fallo de conexión, reconectando ahora...",
  "Copy Message": "Copiar mensaje",
  "Create": "Crear",
  "Create a question, add options, and configure poll settings": "Crea una pregunta, añade opciones y configura los ajustes de la encuesta",
  "Create poll": "Crear encuesta",
  "Current location": "Ubicación actual",
  "Delete": "Borrar",
  "Delete for me": "Eliminar para mí",
  "Delete message": "Eliminar mensaje",
  "Delivered": "Entregado",
  "Direct message": "Mensaje directo",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "¿Quieres terminar esta encuesta ahora? Nadie podrá votar más en esta encuesta.",
  "Download All": "Descargar todo",
  "Download Attachment": "Descargar archivo adjunto",
  "Download attachment {{ name }}": "Descargar adjunto {{ name }}",
  "Drag your files here": "Arrastra tus archivos aquí",
  "Drag your files here to add to your post": "Arrastra tus archivos aquí para agregarlos a tu publicación",
  "Due {{ timeLeft }}": "Vence en {{ timeLeft }}",
  "Due since {{ dueSince }}": "Vencido desde {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Editar mensaje",
  "Edit message request failed": "Error al editar la solicitud de mensaje",
  "Edited": "Editado",
  "Emoji matching": "Coincidencia de emoji",
  "Empty message...": "Mensaje vacío...",
  "End": "Final",
  "End poll": "Terminar encuesta",
  "End this poll?": "¿Terminar esta encuesta?",
  "End vote": "Finalizar votación",
  "Enforce unique vote is enabled": "El voto único está habilitado",
  "Error": "Error",
  "Error adding flag": "Error al agregar la bandera",
  "Error connecting to chat, refresh the page to try again.": "Error al conectarse al chat, actualice la página para volver a intentarlo.",
  "Error deleting message": "Error al eliminar el mensaje",
  "Error fetching reactions": "Error al cargar las reacciones",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Error al marcar el mensaje como no leído. No se pueden marcar mensajes no leídos más antiguos que los últimos 100 mensajes del canal.",
  "Error muting a user ...": "Error al silenciar el usuario...",
  "Error pinning message": "Error al fijar el mensaje",
  "Error removing message pin": "Error al quitar el pin del mensaje",
  "Error reproducing the recording": "Error al reproducir la grabación",
  "Error starting recording": "Error al iniciar la grabación",
  "Error unmuting a user ...": "Error al desactivar el silencio del usuario...",
  "Error uploading attachment": "Error al subir el archivo adjunto",
  "Error uploading file": "Error al cargar el archivo",
  "Error uploading image": "Error al subir la imagen",
  "Error: {{ errorMessage }}": "Error: {{ errorMessage }}",
  "Exit command {{ command }}": "Salir del comando {{ command }}",
  "Failed to block user": "No se pudo bloquear al usuario",
  "Failed to create the poll": "Error al crear la encuesta",
  "Failed to create the poll due to {{reason}}": "No se pudo crear la encuesta debido a {{reason}}",
  "Failed to delete the message": "No se pudo eliminar el mensaje",
  "Failed to end the poll": "No se pudo terminar la encuesta",
  "Failed to end the poll due to {{reason}}": "No se pudo terminar la encuesta debido a {{reason}}",
  "Failed to jump to the first unread message": "Error al saltar al primer mensaje no leído",
  "Failed to leave channel": "No se pudo salir del canal",
  "Failed to load channels": "No se pudieron cargar los canales",
  "Failed to load more channels": "No se pudieron cargar más canales",
  "Failed to mark channel as read": "Error al marcar el canal como leído",
  "Failed to play the recording": "No se pudo reproducir la grabación",
  "Failed to retrieve location": "No se pudo obtener la ubicación",
  "Failed to share location": "No se pudo compartir la ubicación",
  "Failed to update channel archive status": "No se pudo actualizar el estado de archivo del canal",
  "Failed to update channel mute status": "No se pudo actualizar el estado de silencio del canal",
  "Failed to update channel pinned status": "No se pudo actualizar el estado de fijación del canal",
  "File": "Archivo",
  "File is required for upload attachment": "Se requiere un archivo para subir el adjunto",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "El archivo es demasiado grande: {{ size }}, el tamaño máximo de carga es de {{ limit }}",
  "File too large": "Archivo demasiado grande",
  "fileCount_one": "1 archivo",
  "fileCount_many": "{{ count }} archivos",
  "fileCount_other": "{{ count }} archivos",
  "Flag": "Marcar",
  "Generating...": "Generando...",
  "giphy-command-args": "[texto]",
  "giphy-command-description": "Publicar un gif aleatorio en el canal",
  "Hide who voted": "Ocultar quién votó",
  "Image": "Imagen",
  "imageCount_one": "Imagen",
  "imageCount_many": "{{ count }} imágenes",
  "imageCount_other": "{{ count }} imágenes",
  "Instant commands": "Comandos instantáneos",
  "language/af": "Afrikáans",
  "language/am": "Amárico",
  "language/ar": "Árabe",
  "language/az": "Azerbaiyano",
  "language/bg": "Búlgaro",
  "language/bn": "Bengalí",
  "language/bs": "Bosnio",
  "language/cs": "Checo",
  "language/da": "Danés",
  "language/de": "Alemán",
  "language/el": "Griego",
  "language/en": "Inglés",
  "language/es": "Español",
  "language/es-MX": "Español (México)",
  "language/et": "Estonio",
  "language/fa": "Persa",
  "language/fa-AF": "Dari",
  "language/fi": "Finlandés",
  "language/fr": "Francés",
  "language/fr-CA": "Francés (Canadá)",
  "language/ha": "Hausa",
  "language/he": "Hebreo",
  "language/hi": "Hindi",
  "language/hr": "Croata",
  "language/ht": "Criollo haitiano",
  "language/hu": "Húngaro",
  "language/id": "Indonesio",
  "language/it": "Italiano",
  "language/ja": "Japonés",
  "language/ka": "Georgiano",
  "language/ko": "Coreano",
  "language/lt": "Lituano",
  "language/lv": "Letón",
  "language/ms": "Malayo",
  "language/nl": "Neerlandés",
  "language/no": "Noruego",
  "language/pl": "Polaco",
  "language/ps": "Pastún",
  "language/pt": "Portugués",
  "language/ro": "Rumano",
  "language/ru": "Ruso",
  "language/sk": "Eslovaco",
  "language/sl": "Esloveno",
  "language/so": "Somalí",
  "language/sq": "Albanés",
  "language/sr": "Serbio",
  "language/sv": "Sueco",
  "language/sw": "Suajili",
  "language/ta": "Tamil",
  "language/th": "Tailandés",
  "language/tl": "Tagalo",
  "language/tr": "Turco",
  "language/uk": "Ucraniano",
  "language/ur": "Urdu",
  "language/vi": "Vietnamita",
  "language/zh": "Chino (simplificado)",
  "language/zh-TW": "Chino (tradicional)",
  "Leave Channel": "Abandonar canal",
  "Left channel": "Canal abandonado",
  "Let others add options": "Permitir que otros añadan opciones",
  "Limit votes per person": "Limitar votos por persona",
  "Link": "Enlace",
  "linkCount_one": "Enlace",
  "linkCount_many": "{{ count }} enlaces",
  "linkCount_other": "{{ count }} enlaces",
  "live": "En vivo",
  "Live for {{duration}}": "En vivo durante {{duration}}",
  "Live location": "Ubicación en vivo",
  "Live until {{ timestamp }}": "En vivo hasta {{ timestamp }}",
  "Load more": "Cargar más",
  "Local upload attachment missing local id": "El adjunto de subida local no tiene id local",
  "Location": "Ubicación",
  "Location sharing ended": "Compartir ubicación terminado",
  "Location: {{ coordinates }}": "Ubicación: {{ coordinates }}",
  "Mark as unread": "Marcar como no leído",
  "Maximum number of votes (from 2 to 10)": "Número máximo de votos (de 2 a 10)",
  "Maximum votes per person": "Máximo de votos por persona",
  "Menu": "Menú",
  "Message deleted": "Mensaje eliminado",
  "Message failed to send": "No se pudo enviar el mensaje",
  "Message has been successfully flagged": "El mensaje se marcó correctamente",
  "Message marked as unread": "Mensaje marcado como no leído",
  "Message pinned": "Mensaje fijado",
  "Message unpinned": "Mensaje desanclado",
  "Message was blocked by moderation policies": "El mensaje fue bloqueado por las políticas de moderación",
  "Messages have been marked unread.": "Los mensajes han sido marcados como no leídos.",
  "Missing permissions to upload the attachment": "Faltan permisos para subir el archivo adjunto",
  "Multiple votes": "Votos múltiples",
  "Mute": "Silenciar",
  "mute-command-args": "[@usuario]",
  "mute-command-description": "Silenciar a un usuario",
  "network error": "error de red",
  "New": "Nuevo",
  "New message from {{user}}": "Nuevo mensaje de {{user}}",
  "New Messages!": "¡Nuevos mensajes!",
  "Next image": "Siguiente imagen",
  "No chats here yet…": "Aún no hay mensajes aquí...",
  "No conversations yet": "Aún no hay conversaciones",
  "No items exist": "No existen elementos",
  "No results found": "No se han encontrado resultados",
  "Nobody will be able to vote in this poll anymore.": "Nadie podrá votar en esta encuesta.",
  "Nothing yet...": "Nada aún...",
  "Offline": "Desconectado",
  "Ok": "Aceptar",
  "Online": "En línea",
  "Only numbers are allowed": "Solo se permiten números",
  "Only visible to you": "Solo visible para ti",
  "Open emoji picker": "Abrir el selector de emojis",
  "Open gallery at image {{ index }}": "Abrir galería en la imagen {{ index }}",
  "Open image in gallery": "Abrir imagen en la galería",
  "Open location in a map": "Abrir ubicación en un mapa",
  "Option already exists": "La opción ya existe",
  "Option is empty": "La opción está vacía",
  "Options": "Opciones",
  "Original": "Original",
  "People matching": "Personas que coinciden",
  "Photo": "Foto",
  "Pin": "Fijar",
  "Pinned by {{ name }}": "Fijado por {{ name }}",
  "Pinned by You": "Anclado por ti",
  "placeholder/PollComment": "Tu comentario",
  "placeholder/PollOptionSuggestion": "Introduce una nueva opción",
  "Play video": "Reproducir video",
  "Playback speed {{ rate }}x": "Velocidad de reproducción {{ rate }}x",
  "Poll": "Encuesta",
  "Poll comments": "Comentarios de la encuesta",
  "Poll ended": "Encuesta finalizada",
  "Poll options": "Opciones de la encuesta",
  "Poll results": "Resultados de la encuesta",
  "Previous image": "Imagen anterior",
  "Question": "Pregunta",
  "Question {{ optionOrderNumber}}": "Pregunta {{ optionOrderNumber}}",
  "Question is required": "La pregunta es obligatoria",
  "Quote Reply": "Responder con cita",
  "Reached the vote limit. Remove an existing vote first.": "Se ha alcanzado el límite de votos. Elimina un voto existente primero.",
  "Recording format is not supported and cannot be reproduced": "El formato de grabación no es compatible y no se puede reproducir",
  "Remind me": "Recordarme",
  "Remind Me": "Recordarme",
  "Reminder set": "Recordatorio establecido",
  "Remove reminder": "Eliminar recordatorio",
  "Remove save for later": "Quitar guardar para después",
  "Replied to a thread": "Respondió en un hilo",
  "Reply": "Responder",
  "Reply to {{ authorName }}": "Responder a {{ authorName }}",
  "Reply to a message to start a thread": "Responde a un mensaje para iniciar un hilo",
  "Reply to Message": "Responder al mensaje",
  "replyCount_one": "1 respuesta",
  "replyCount_many": "{{ count }} respuestas",
  "replyCount_other": "{{ count }} respuestas",
  "Resend": "Reenviar",
  "Retry upload": "Reintentar la carga",
  "Review all options available in this poll": "Revisa todas las opciones disponibles en esta encuesta",
  "Review comments submitted with poll answers": "Revisa los comentarios enviados con las respuestas de la encuesta",
  "Review poll results and open an option to see detailed votes": "Revisa los resultados de la encuesta y abre una opción para ver votos detallados",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Revisa este mensaje y elige si eliminarlo, editarlo o enviarlo de todos modos",
  "Review who voted for this option": "Revisa quién votó por esta opción",
  "Save for later": "Guardar para más tarde",
  "Saved for later": "Guardado para más tarde",
  "Search": "Buscar",
  "Search GIFs": "Buscar GIFs",
  "search-results-header-filter-source-button-label--channels": "canales",
  "search-results-header-filter-source-button-label--messages": "mensajes",
  "search-results-header-filter-source-button-label--users": "usuarios",
  "Searching for {{ searchSourceType }}...": "Buscando {{ searchSourceType }}...",
  "Searching...": "Buscando...",
  "searchResultsCount_one": "1 resultado",
  "searchResultsCount_many": "{{ count }} resultados",
  "searchResultsCount_other": "{{ count }} resultados",
  "Select a thread to continue the conversation": "Selecciona un hilo para continuar la conversación",
  "Select more than one option": "Seleccionar más de una opción",
  "Select one": "Seleccionar uno",
  "Select one or more": "Seleccionar uno o más",
  "Select up to {{count}}_one": "Selecciona hasta {{count}}",
  "Select up to {{count}}_many": "Selecciona hasta {{count}}",
  "Select up to {{count}}_other": "Selecciona hasta {{count}}",
  "Select your current location and optionally enable live location sharing": "Selecciona tu ubicación actual y, opcionalmente, habilita el uso compartido de ubicación en vivo",
  "Send": "Enviar",
  "Send a message": "Envía un mensaje",
  "Send a message to start the conversation": "Envía un mensaje para iniciar la conversación",
  "Send Anyway": "Enviar de todos modos",
  "Send message request failed": "Error al enviar la solicitud de mensaje",
  "Send poll": "Enviar encuesta",
  "Sending...": "Enviando...",
  "Sent": "Enviado",
  "Share": "Compartir",
  "Share live location for": "Compartir ubicación en vivo durante",
  "Share Location": "Compartir ubicación",
  "Shared live location": "Ubicación en vivo compartida",
  "Shared location": "Ubicación compartida",
  "Shuffle": "Mezclar",
  "size limit": "límite de tamaño",
  "Slow Mode ON": "Modo lento activado",
  "Slow mode, wait {{ seconds }}s...": "Modo lento, espera {{ seconds }} s...",
  "Some of the files will not be accepted": "Algunos archivos no serán aceptados",
  "Start typing to search": "Empieza a escribir para buscar",
  "Stop sharing": "Dejar de compartir",
  "Submit": "Enviar",
  "Suggest a new option to add to this poll": "Sugiere una nueva opción para añadir a esta encuesta",
  "Suggest an option": "Sugerir una opción",
  "Tap to remove": "Toca para quitar",
  "Tap to remove: {{ reactionName }}": "Toca para quitar: {{ reactionName }}",
  "Thinking...": "Pensando...",
  "this content could not be displayed": "Este contenido no se pudo mostrar",
  "This field cannot be empty or contain only spaces": "Este campo no puede estar vacío o contener solo espacios",
  "This message did not meet our content guidelines": "Este mensaje no cumple con nuestras directrices de contenido",
  "Thread": "Hilo",
  "Thread has not been found": "No se ha encontrado el hilo",
  "Thread reply": "Respuesta en hilo",
  "Thread Reply": "Respuesta en hilo",
  "ThreadListUnseenThreadsBanner/loading": "Cargando...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} hilo no leído",
  "ThreadListUnseenThreadsBanner/unreadThreads_many": "{{ count }} hilos no leídos",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} hilos no leídos",
  "Threads": "Hilos",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Ayer]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Hoy]\", \"nextDay\": \"[Mañana]\", \"lastDay\": \"[Ayer]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Último] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Hoy",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Ayer",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Para comenzar a grabar, permita el acceso a la cámara en su navegador",
  "To start recording, allow the microphone access in your browser": "Para comenzar a grabar, permita el acceso al micrófono en su navegador",
  "totalVoteCount_one": "1 voto en total",
  "totalVoteCount_many": "{{ count }} votos en total",
  "totalVoteCount_other": "{{ count }} votos en total",
  "Translated": "Traducido",
  "Translated from {{ language }}": "Traducido de {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Escribe un número del 2 al 10",
  "Unarchive": "Desarchivar",
  "unban-command-args": "[@usuario]",
  "unban-command-description": "Quitar la prohibición a un usuario",
  "Unblock User": "Desbloquear usuario",
  "unknown error": "error desconocido",
  "Unmute": "Activar sonido",
  "unmute-command-args": "[@usuario]",
  "unmute-command-description": "Desactivar el silencio de un usuario",
  "Unpin": "Desfijar",
  "Unread messages": "Mensajes no leídos",
  "Unsupported attachment": "Adjunto no compatible",
  "unsupported file type": "tipo de archivo no compatible",
  "Update": "Actualizar",
  "Update the comment attached to your poll answer": "Actualiza el comentario adjunto a tu respuesta de la encuesta",
  "Update your comment": "Actualizar tu comentario",
  "Upload blocked": "Carga bloqueada",
  "Upload error": "Error de carga",
  "Upload failed": "Carga fallida",
  "Upload type: \"{{ type }}\" is not allowed": "Tipo de carga: \"{{ type }}\" no está permitido",
  "User blocked": "Usuario bloqueado",
  "User unblocked": "Usuario desbloqueado",
  "User uploaded content": "Contenido subido por el usuario",
  "Video": "Vídeo",
  "videoCount_one": "Video",
  "videoCount_many": "{{ count }} videos",
  "videoCount_other": "{{ count }} videos",
  "View": "Ver",
  "View {{count}} comments_one": "Ver {{count}} comentario",
  "View {{count}} comments_many": "Ver {{count}} comentarios",
  "View {{count}} comments_other": "Ver {{count}} comentarios",
  "View all": "Ver todo",
  "View original": "Ver original",
  "View results": "Ver resultados",
  "View translation": "Ver traducción",
  "Voice message": "Mensaje de voz",
  "Voice message {{ duration }}": "Mensaje de voz {{ duration }}",
  "Voice message deleted": "Mensaje de voz eliminado",
  "voiceMessageCount_one": "Mensaje de voz",
  "voiceMessageCount_many": "{{ count }} mensajes de voz",
  "voiceMessageCount_other": "{{ count }} mensajes de voz",
  "Vote ended": "Votación finalizada",
  "Votes": "Votos",
  "Wait until all attachments have uploaded": "Espere hasta que se hayan cargado todos los archivos adjuntos",
  "Waiting for network…": "Esperando red…",
  "You": "Tú",
  "You've reached the maximum number of files": "Has alcanzado el número máximo de archivos"
}
